/* eslint-disable no-control-regex */

export default function base64url(data: any): string {
  if (typeof data !== 'string') {
    data = JSON.stringify(data)
  }

  return toBase64(data)
    .replace(/[+/]/g, (c) => subst[c])
    .replace(/={1,3}$/, '')
}

function toBase64(str: string): string {
  if (isBtoaPatched()) {
    return btoa(str)
  }
  return btoa(toBinary(str))
}

// Importing certain packages in Velo (for example 'wix-bookings-backend')
// patches btoa.
// https://wix.slack.com/archives/CA5PUAXL5/p1718090111259899
function isBtoaPatched() {
  try {
    return btoa('🦄') === '8J+mhA=='
  } catch (e) {
    return false
  }
}

const subst: Record<string, string> = {
  '+': '-',
  '/': '_',
}

function toBinary(s: string) {
  if (typeof TextEncoder === 'function') {
    const bytes = new TextEncoder().encode(s)
    return Array.from(bytes, (byte) => String.fromCodePoint(byte)).join('')
  }

  return s.replace(nonAsciiRegex, toBytes)
}

const nonAsciiRegex = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g

const fromCode = (code: number) => String.fromCharCode(code)

function toBytes(c: string) {
  if (c.length < 2) {
    const cc = c.charCodeAt(0)
    return cc < 0x80
      ? c
      : cc < 0x800
      ? fromCode(0xc0 | (cc >>> 6)) + fromCode(0x80 | (cc & 0x3f))
      : fromCode(0xe0 | ((cc >>> 12) & 0x0f)) +
        fromCode(0x80 | ((cc >>> 6) & 0x3f)) +
        fromCode(0x80 | (cc & 0x3f))
  }
  const cc =
    0x10000 + (c.charCodeAt(0) - 0xd800) * 0x400 + (c.charCodeAt(1) - 0xdc00)
  return (
    fromCode(0xf0 | ((cc >>> 18) & 0x07)) +
    fromCode(0x80 | ((cc >>> 12) & 0x3f)) +
    fromCode(0x80 | ((cc >>> 6) & 0x3f)) +
    fromCode(0x80 | (cc & 0x3f))
  )
}
